/**
 * Where a visitor came from, kept long enough to reach checkout.
 *
 * An ad click lands with ?utm_source=...&utm_campaign=... on the URL. By the
 * time the visitor clicks "Enroll" they may have scrolled, opened the FAQ and
 * changed the hash, so the parameters are gone from the address bar. This
 * writes them down on arrival (first touch wins, kept 30 days) and hands them
 * to the checkout, which stores them on the Stripe session. That is how a
 * cert sale can be traced back to the ad that started it.
 *
 * Reads both the real query string and a query inside the hash
 * (#/certification?utm_source=x), because both shapes get shared.
 */
const KEY = "bam_ad_source";
const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;

export function readAdParams(search = "", hash = "") {
  const out = {};
  const sources = [search, (hash.split("?")[1] || "")];
  for (const src of sources) {
    const params = new URLSearchParams(src.startsWith("?") ? src.slice(1) : src);
    for (const k of KEYS) {
      const v = params.get(k);
      if (v && !out[k]) out[k] = v.slice(0, 120);
    }
  }
  return out;
}

export function captureAdSource(loc = typeof window !== "undefined" ? window.location : null, store = safeStorage()) {
  if (!loc || !store) return;
  const found = readAdParams(loc.search || "", loc.hash || "");
  if (!Object.keys(found).length) return;
  const existing = getAdSource(store);
  if (Object.keys(existing).length) return; // first touch wins
  try { store.setItem(KEY, JSON.stringify({ ...found, at: Date.now() })); } catch {}
}

export function getAdSource(store = safeStorage(), now = Date.now()) {
  if (!store) return {};
  try {
    const raw = JSON.parse(store.getItem(KEY) || "null");
    if (!raw || typeof raw !== "object") return {};
    if (!raw.at || now - raw.at > MAX_AGE_MS) return {};
    const out = {};
    for (const k of KEYS) if (raw[k]) out[k] = raw[k];
    return out;
  } catch { return {}; }
}

function safeStorage() {
  try { return typeof window !== "undefined" ? window.localStorage : null; } catch { return null; }
}
